import { render, staticRenderFns } from "./PricingView.vue?vue&type=template&id=670eec81"
import script from "./PricingView.vue?vue&type=script&lang=js"
export * from "./PricingView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('670eec81')) {
      api.createRecord('670eec81', component.options)
    } else {
      api.reload('670eec81', component.options)
    }
    module.hot.accept("./PricingView.vue?vue&type=template&id=670eec81", function () {
      api.rerender('670eec81', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/superadmin/vehiclelookup/PricingView.vue"
export default component.exports